import React, { createContext, useContext, useRef, useCallback } from "react";

const AudioCtx = createContext(null);

export function AudioProvider({ children }) {
  const ctxRef = useRef(null);
  const masterRef = useRef(null);

  const getCtx = useCallback(() => {
    if (!ctxRef.current) {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const master = ctx.createGain();
      master.gain.value = 1;
      master.connect(ctx.destination);
      ctxRef.current = ctx;
      masterRef.current = master;
    }
    if (ctxRef.current.state === "suspended") {
      ctxRef.current.resume();
    }
    return ctxRef.current;
  }, []);

  const getMaster = useCallback(() => {
    getCtx();
    return masterRef.current;
  }, [getCtx]);

  return (
    <AudioCtx.Provider value={{ getCtx, getMaster }}>
      {children}
    </AudioCtx.Provider>
  );
}

export function useAudio() {
  return useContext(AudioCtx);
}
